import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { APP_VERSION } from '@app/constants';
import { User } from '@interfaces/user';
import { TranslateService } from '@ngx-translate/core';
import { DeviceTypeService } from '@services/device-type.service';
import { NavigationService } from '@services/navigation.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  standalone: false,
})
export class DashboardComponent implements OnInit {
  public userProfile!: User | null;
  public appVersion = APP_VERSION;
  public loading = false;
  public currentRouteUrl = '';

  constructor(
    public translateService: TranslateService,
    public router: Router,
    public navigationService: NavigationService,
    public deviceType: DeviceTypeService,
  ) {}

  ngOnInit(): void {
    this.router.events.subscribe((event: any) => {
      this.currentRouteUrl = event?.routerEvent?.url;
    });
  }
}
